import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, NODE_COLORS } from "../../services/api";
import GraphView from "../../components/GraphView";

export default function VansGraph() {
  const [graph, setGraph] = useState(null);
  const [focus, setFocus] = useState("");
  const [params] = useSearchParams();

  useEffect(() => {
    const f = params.get("focus");
    if (f) { setFocus(f); api.vansGraph(f).then(setGraph); }
    else api.vansGraph().then(setGraph);
  }, [params]);

  const refocus = (id) => { setFocus(id); api.vansGraph(id).then(setGraph); };
  const reset = () => { setFocus(""); api.vansGraph().then(setGraph); };

  return (
    <div className="graph-page">
      <div className="graph-toolbar">
        <div className="graph-legend">
          {["objective", "sku", "region", "warehouse", "dealer"].map((t) => (
            <span key={t} className="gl-item"><i style={{ background: NODE_COLORS[t] }} />{t === "sku" ? "style" : t === "warehouse" ? "DC" : t}</span>
          ))}
        </div>
        <div className="graph-tb-actions">
          {focus && <span className="focus-chip">Focused: {focus}</span>}
          {focus && <button className="btn-ghost sm" onClick={reset}>Show full graph</button>}
        </div>
      </div>
      <div className="graph-canvas-wrap">
        {graph ? <GraphView nodes={graph.nodes} edges={graph.edges} onNodeClick={refocus} />
          : <div className="loading-page">Building Vans context graph…</div>}
      </div>
      <div className="graph-hint">Vans enterprise map — styles sell into regions, stock at regional DCs, and reach dealers. Click any node to traverse its neighbourhood.</div>
    </div>
  );
}
